// ROC.js
import * as d3 from 'd3';
import theme from '../../theme';

export const drawROC = (svg, data, xScale, yScale, values, strokeColor) => {
    if (!values || !Array.isArray(values)) return;

    const validPoints = values.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    if (validPoints.length === 0) return;

    const lineGenerator = d3.line()
        .x(d => xScale(d.x))
        .y(d => yScale(d.y))
        .curve(d3.curveMonotoneX);

    // Two sign-filtered area passes (not one path with a per-datum fill --
    // that silently evaluated `d.y` against the whole bound array since the
    // path is a single `.datum()`, always taking the same branch) so
    // positive/negative segments actually get distinct bull/bear colors.
    const areaAbove = d3.area()
        .x(d => xScale(d.x))
        .y0(yScale(0))
        .y1(d => yScale(d.y))
        .defined(d => d.y >= 0)
        .curve(d3.curveMonotoneX);
    const areaBelow = d3.area()
        .x(d => xScale(d.x))
        .y0(yScale(0))
        .y1(d => yScale(d.y))
        .defined(d => d.y < 0)
        .curve(d3.curveMonotoneX);

    svg.append('path').datum(validPoints).attr('fill', theme.bull.strong).attr('opacity', 0.25).attr('d', areaAbove);
    svg.append('path').datum(validPoints).attr('fill', theme.bear.strong).attr('opacity', 0.25).attr('d', areaBelow);

    svg.append('path')
        .datum(validPoints)
        .attr('fill', 'none')
        .attr('stroke', strokeColor)
        .attr('stroke-width', 2)
        .attr('d', lineGenerator);
};